module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty":"No coins found with these criterias..."},"fr":{"empty":"Aucune pièce n’a été trouvée avec ces critères…"}}')
  delete Component.options._Ctor
}
